module.exports = __webpack_public_path__ + "static/media/logo.19d5e51d.png";